module.exports = __webpack_public_path__ + "static/img/404.17e73659.png";